export const APP_VERSION: string = process.env.APP_VERSION || 'local-dev';

type DatamanEnvs = 'production' | 'staging' | 'development';
export const API_ENV = process.env.NEXT_PUBLIC_APP_ENV as DatamanEnvs | undefined;
export const IS_STAGING: boolean = Boolean(API_ENV !== 'production');
export const LOGIN_CLIENT_ID: string = process.env.NEXT_PUBLIC_CLIENT_ID ?? '1aaba4d95b8f5100df0208e11006afbe';
export const LOGIN_CLIENT_SECRET: string = process.env.NEXT_PUBLIC_CLIENT_SECRET ?? 'd4be55f54a6e999f278fa4c6dc50d139';
export const COMMIT_SHA: string = process.env.NEXT_PUBLIC_COMMIT_SHA ?? 'unknown';
export const DATAMAN_URL: `https://${string}` =
  (process.env.NEXT_PUBLIC_DATAMAN_URL as `https://${string}`) ?? 'https://dataman.youversionapistaging.com/4.0/events';
